import { Form, Formik } from 'formik';
import { useRef } from 'react';
import * as yup from 'yup';
import { resetPasswordApi } from '../../api/auth-user-api';
import toast from 'react-hot-toast';
import { Flex } from 'antd';
import { Button, Input } from '../../common';
import { getErrorString } from '../../utils';
import { useNavigate } from 'react-router-dom';
import { USER_SIGNIN_PATH } from '../../constants/user-paths';
import { removeSingleCookie } from '../../utils/cookies-util';
import { regex } from 'constants/generic-regex';

export default function ResetForm({ token }) {
  const formikRef = useRef();
  const navigate = useNavigate();

  const getValidationSchema = () =>
    yup.object().shape({
      password: yup
        .string()
        .min(8, 'Password must be at least 8 characters')
        .max(64, 'Password must not exceed 64 characters')
        .matches(regex.password, 'Password must contain only letters, numbers, and symbols. Spaces are not allowed.')
        .required('Password is required'),
      confirmPassword: yup
        .string()
        .required('Confirm Password is required')
        .oneOf([yup.ref('password'), null], 'Passwords must match'),
    });

  const getInitialValues = () => ({});

  const onSubmit = async (values, { setSubmitting, setStatus }) => {
    setSubmitting(true);
    try {
      const data = {
        reset_password_token: token || '',
        password: values?.password || '',
      };
      const res = await resetPasswordApi(data);
      if (res && res?.status) {
        removeSingleCookie('resend-link-time');
        toast.success(res?.message || 'Your password has been reset. Please log in to continue.');
        return navigate(USER_SIGNIN_PATH);
      } else {
        toast.error(res?.message ?? 'Request Failed');
        setStatus({ message: res?.message });
        return;
      }
    } catch (error) {
      toast.error(getErrorString(error));
      setStatus({ message: getErrorString(error) });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={getInitialValues()}
      validationSchema={getValidationSchema}
      onSubmit={onSubmit}
    >
      {({ values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting, status, setStatus }) => (
        <Form onSubmit={handleSubmit} className={'authWrap'}>
          <Flex vertical gap={40}>
            <Flex vertical justify="start" align="start" gap={8}>
              <h2 className="heading-text">Reset Password</h2>
              <h5 className="subheading-text">Enter your new password</h5>
            </Flex>
            <Flex vertical gap={24}>
              <Flex vertical gap={20}>
                <Input
                  isPassword={true}
                  className={'h5-regular input-box'}
                  placeholder="Enter Password"
                  name="password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.password}
                  errorMsg={errors.password && touched.password && errors.password}
                />
                <Input
                  isPassword={true}
                  className={'h5-regular input-box'}
                  placeholder="Confirm Password"
                  name="confirmPassword"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.confirmPassword}
                  errorMsg={errors.confirmPassword && touched.confirmPassword && errors.confirmPassword}
                />
              </Flex>
              <Button
                className={'h4-medium primary-button'}
                text={'Reset Password'}
                type="primary"
                size="large"
                onClick={handleSubmit}
                loading={isSubmitting}
              />
            </Flex>
          </Flex>
        </Form>
      )}
    </Formik>
  );
}
